import React from "react";
import BlueImage from "../../assets/images/New folder/banner.jpeg";
function Banner() {
  return (
    <div className="container">
      <img
        src={BlueImage}
        alt="Maged Bannar"
        className="img-fluid my-3"
        style={{ borderRadius: "10px", width: "100%" }}
      />
    </div>
  );
}

export default Banner;
